import React, { useState, useEffect } from 'react'
import { Modal } from 'react-bootstrap'
import classnames from 'classnames'
import { useTranslation } from 'react-i18next'
import _ from 'lodash'
import { getAvailableDriverAvatars } from '../../action/DriverActions'
import CustomButton from '../../component/CustomButton'
import '../../component/smart/modals/Modal.sass'
import './ModalDriverAvatarGallery.sass'

export function ModalDriverAvatarGallery(props) {
	const { driverId, selectedPhotoIds, onSelect, onCancel, toggleLoader } = props;
	const { t } = useTranslation('translation', { keyPrefix: 'driversPage.modalAddAndEditDriver' });
	const [availablePhotos, setAvailablePhotos] = useState([]);
	const [pendingPhotoIds, setPendingPhotoIds] = useState(() => [...selectedPhotoIds]);

	useEffect(() => {
		let active = true;
		toggleLoader(true);
		setAvailablePhotos([]);
		getAvailableDriverAvatars(driverId)
			.then(res => {
				if (!active) return;
				const photos = _.uniqBy(_.get(res, 'data.response.photos', []) || [], 'id');
				setAvailablePhotos(photos);
				setPendingPhotoIds(ids => ids.filter(id => photos.some(photo => photo.id === id)));
			})
			.catch(error => {
				if (!active) return;
				console.log('!getAvailableDriverAvatars error: ', error.response, error);
				setAvailablePhotos([]);
				setPendingPhotoIds([]);
			})
			.finally(() => {
				if (active) toggleLoader(false);
			});
		return () => {
			active = false;
			toggleLoader(false);
		};
	}, [driverId, toggleLoader]);

	const togglePhoto = (photoId) => {
		setPendingPhotoIds(ids => ids.includes(photoId) ? ids.filter(id => id !== photoId) : [...ids, photoId]);
	};

	const selectAvatars = () => {
		if (availablePhotos.length && pendingPhotoIds.length) {
			onSelect(availablePhotos.filter(photo => pendingPhotoIds.includes(photo.id)), availablePhotos.map(photo => photo.id));
		}
	};

	return (
		<Modal
			show
			onHide={onCancel}
			className="modal-lg-size driver-modal driver-avatars-modal"
		>
			<Modal.Header closeButton>
				<Modal.Title>{t('titleAddAvatars')}</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				{availablePhotos.length > 0 ?
					<div className="photos-list">
						{availablePhotos.map(photo =>
							<button
								type="button"
								key={photo.id}
								className="available-avatar"
								aria-pressed={pendingPhotoIds.includes(photo.id)}
								onClick={() => togglePhoto(photo.id)}
							>
								<img className={classnames({ active: pendingPhotoIds.includes(photo.id) })} src={photo.url || photo.snapshot_url || "/images/unknown_driver.svg"} alt="Avatar" />
							</button>
						)}
					</div> :
					<div className="no-avatars">{t('noAvatarsAvailable')}</div>}
			</Modal.Body>
			<Modal.Footer>
				<span className="selected-avatars-count" aria-live="polite">{t('selectedAvatarsCount', { count: availablePhotos.length ? pendingPhotoIds.length : 0 })}</span>
				<CustomButton variant="primary-outline" size="sm" onClick={onCancel}>{t('btnCancel')}</CustomButton>
				<CustomButton variant="primary" size="sm" disabled={!availablePhotos.length || !pendingPhotoIds.length} onClick={selectAvatars}>{t('btnSelectAvatars')}</CustomButton>
			</Modal.Footer>
		</Modal>
	);
}

export default ModalDriverAvatarGallery;
